import { useState } from 'react'

const API = 'https://legado-digital-production.up.railway.app'

function FormularioMascota({ onMascotaCreada, userId }) {
  const [nombre, setNombre] = useState('')
  const [especie, setEspecie] = useState('perro')
  const [raza, setRaza] = useState('')
  const [descripcion, setDescripcion] = useState('')
  const [cuidadorNombre, setCuidadorNombre] = useState('')
  const [cuidadorEmail, setCuidadorEmail] = useState('')
  const [cuidadorTelefono, setCuidadorTelefono] = useState('')
  const [instrucciones, setInstrucciones] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setEnviando(true)
    setError('')
    try {
      const res = await fetch(`${API}/api/mascotas`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, nombre, especie, raza, descripcion, cuidadorNombre, cuidadorEmail, cuidadorTelefono, instrucciones }),
      })
      const datos = await res.json()
      if (!datos.ok) { setError(datos.error || 'Error al añadir mascota'); return }
      setNombre(''); setEspecie('perro'); setRaza(''); setDescripcion('')
      setCuidadorNombre(''); setCuidadorEmail(''); setCuidadorTelefono(''); setInstrucciones('')
      onMascotaCreada(datos.datos)
    } catch {
      setError('No se pudo conectar con el servidor')
    } finally {
      setEnviando(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} style={estilos.formulario}>
      <h3 style={estilos.titulo}>🐾 Añadir mascota</h3>
      <p style={estilos.subtitulo}>Deja instrucciones para quien cuide a tu compañero cuando tú no puedas.</p>
      {error && <div style={estilos.error}>{error}</div>}

      <div style={estilos.grid}>
        <div style={estilos.campo}>
          <label style={estilos.label}>Nombre de la mascota</label>
          <input type="text" placeholder="Ej: Luna" value={nombre} onChange={e => setNombre(e.target.value)} style={estilos.input} required />
        </div>
        <div style={estilos.campo}>
          <label style={estilos.label}>Especie</label>
          <select value={especie} onChange={e => setEspecie(e.target.value)} style={estilos.input}>
            <option value="perro">🐶 Perro</option>
            <option value="gato">🐱 Gato</option>
            <option value="ave">🐦 Ave</option>
            <option value="conejo">🐰 Conejo</option>
            <option value="pez">🐟 Pez</option>
            <option value="reptil">🦎 Reptil</option>
            <option value="otro">Otro</option>
          </select>
        </div>
      </div>

      <div style={estilos.grid}>
        <div style={estilos.campo}>
          <label style={estilos.label}>Raza (opcional)</label>
          <input type="text" placeholder="Ej: Golden Retriever" value={raza} onChange={e => setRaza(e.target.value)} style={estilos.input} />
        </div>
        <div style={estilos.campo}>
          <label style={estilos.label}>Descripción</label>
          <input type="text" placeholder="Ej: 3 años, muy cariñosa" value={descripcion} onChange={e => setDescripcion(e.target.value)} style={estilos.input} />
        </div>
      </div>

      <div style={estilos.seccion}>
        <div style={estilos.seccionTitulo}>👤 Cuidador designado</div>
        <div style={estilos.grid}>
          <div style={estilos.campo}>
            <label style={estilos.label}>Nombre del cuidador</label>
            <input type="text" placeholder="Quien cuidará a tu mascota" value={cuidadorNombre} onChange={e => setCuidadorNombre(e.target.value)} style={estilos.input} />
          </div>
          <div style={estilos.campo}>
            <label style={estilos.label}>Email del cuidador</label>
            <input type="email" placeholder="cuidador@email.com" value={cuidadorEmail} onChange={e => setCuidadorEmail(e.target.value)} style={estilos.input} />
          </div>
        </div>
        <div style={estilos.campo}>
          <label style={estilos.label}>Teléfono del cuidador</label>
          <input type="text" placeholder="+34 600 000 000" value={cuidadorTelefono} onChange={e => setCuidadorTelefono(e.target.value)} style={estilos.input} />
        </div>
      </div>

      <div style={estilos.campo}>
        <label style={estilos.label}>Instrucciones especiales</label>
        <textarea
          placeholder="Ej: Come pienso Royal Canin 2 veces al día. Le gusta dormir en el sofá. Va al veterinario Dr. García, tel: 91 000 0000. Tiene seguro con número 12345..."
          value={instrucciones}
          onChange={e => setInstrucciones(e.target.value)}
          style={{ ...estilos.input, minHeight: '80px', resize: 'vertical' }}
          rows={3}
        />
      </div>

      <button type="submit" disabled={enviando} style={{ ...estilos.boton, opacity: enviando ? 0.7 : 1 }}>
        {enviando ? 'Guardando...' : '🐾 Añadir mascota al legado'}
      </button>
    </form>
  )
}

const estilos = {
  formulario: { backgroundColor: '#ffffff', borderRadius: '12px', padding: '20px', border: '1px solid #E8E0D5', marginBottom: '24px' },
  titulo: { fontSize: '16px', fontWeight: '600', marginBottom: '4px', color: '#2C1810' },
  subtitulo: { fontSize: '13px', color: '#8B6F47', marginBottom: '16px', lineHeight: '1.5' },
  seccion: { backgroundColor: '#FAF8F5', borderRadius: '8px', padding: '14px', marginBottom: '14px', border: '1px solid #E8E0D5' },
  seccionTitulo: { fontSize: '13px', fontWeight: '600', color: '#2C1810', marginBottom: '12px' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  campo: { marginBottom: '14px' },
  label: { display: 'block', fontSize: '13px', fontWeight: '500', color: '#2C1810', marginBottom: '6px' },
  input: { width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #E8E0D5', fontSize: '14px', outline: 'none', backgroundColor: '#fff', fontFamily: 'inherit' },
  boton: { width: '100%', padding: '12px', backgroundColor: '#2C1810', color: '#FAF8F5', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', marginTop: '4px' },
  error: { backgroundColor: '#FDF0EC', color: '#8B2E0F', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '14px', border: '1px solid #F5C9B8' },
}

export default FormularioMascota